import { Box, Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import * as React from "react";
import { ApplicationPermissionType, EnumHelper } from "ui/Scripts/source/models/enums";
import { IApplicationPermission } from "../../../models/common/applicationPermission";
import { PermissionIcon } from "../../framework/Icon/PermissionIcon";

interface ICompanyEditPermissionsProp {
    applicationPermissions: IApplicationPermission[];
    onSetValue: (applicationPermissionType: ApplicationPermissionType, value: boolean) => void;
}

export const CompanyEditPermissions = (props: ICompanyEditPermissionsProp) => {
    const applicationPermissions = props.applicationPermissions;
    if (!applicationPermissions || applicationPermissions.length < 0) return null;

    const half = Math.floor(applicationPermissions.length / 2);
    const offset = applicationPermissions.length % 2 === 0 ? 0 : 1;

    return (
        <Grid container>
            <Grid item sm={6}>
                <Grid container>
                    {props.applicationPermissions.map((_applicationPermission, index) => {
                        const applicationPermissionIndex = index % 2 === 0
                            ? index / 2
                            : half + Math.floor(index / 2) + offset;
                        const applicationPermission = applicationPermissions[applicationPermissionIndex];
                        return (
                            <Grid item sm={6} key={applicationPermission.type} className="applicationPermissionLine">
                                <FormControlLabel
                                    label={
                                        <Box display="flex" alignItems="center">
                                            <PermissionIcon type={applicationPermission.type} />
                                            <Typography sx={{ marginLeft: ".5rem" }}>
                                                {EnumHelper.ApplicationPermissionTypeToStr(applicationPermission.type)}
                                            </Typography>
                                        </Box>
                                    }
                                    control={
                                        <Checkbox
                                            checked={applicationPermission.level > 0}
                                            onChange={(_e, checked: boolean) => props.onSetValue(applicationPermission.type, checked)}
                                        />
                                    }
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid>
        </Grid>
    );
};